import { createStandardAction } from 'typesafe-actions';

import type { Notification } from 'Notification-Types';

export const setNotification = createStandardAction('SET_NOTIFICATION')<Notification>();
export const clearNotification = createStandardAction('CLEAR_NOTIFICATION')();
